import { useState, useCallback } from 'react';
import deviceTemplateService from '../services/deviceTemplateService';

export const useDeviceTemplates = (deviceId) => {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const loadTemplates = useCallback(async () => {
    if (!deviceId) return;
    setLoading(true);
    setError(null);
    try {
      const response = await deviceTemplateService.getAllDeviceTemplates(deviceId);
      if (response.success) {
        // La nueva estructura del backend puede tener templates en data.templates
        setTemplates(response.data?.templates || response.data || []);
      } else {
        setError(response.message);
        setTemplates([]);
      }
    } catch (err) {
      setError(err.message);
      setTemplates([]);
    } finally {
      setLoading(false);
    }
  }, [deviceId]);

  const createTemplate = async (templateData) => {
    if (!deviceId) {
      throw new Error('Device ID es requerido para crear plantilla');
    }
    setLoading(true);
    setError(null);
    try {
      const result = await deviceTemplateService.createDeviceTemplate(deviceId, templateData);
      if (result.success) {
        await loadTemplates(); // Recargar las plantillas después de crear
      }
      return result;
    } catch (err) {
      setError(err.message);
      return { success: false, message: err.message };
    } finally {
      setLoading(false);
    }
  };

  const updateTemplate = async (templateId, templateData) => {
    if (!deviceId) {
      throw new Error('Device ID es requerido para actualizar plantilla');
    }
    setLoading(true);
    setError(null);
    try {
      const result = await deviceTemplateService.updateDeviceTemplate(deviceId, templateId, templateData);
      if (result.success) {
        await loadTemplates(); // Recargar las plantillas después de actualizar
      }
      return result;
    } catch (err) {
      setError(err.message);
      return { success: false, message: err.message };
    } finally {
      setLoading(false);
    }
  };

  return {
    templates,
    loading,
    error,
    loadTemplates,
    updateTemplate,
    createTemplate,
  };
}; 